export function drawPanelLines(
  printPositionHeight: number,
  xPositionOfDottedLine: number
): any {
  const lines = [];
  let space = 0;

  lines.push({
    x1: xPositionOfDottedLine,
    y1: 0,
    x2: xPositionOfDottedLine,
    y2: 20,
    strokeColor: [1, 0, 0],
  });

  for (let index = 1; space < printPositionHeight; index++) {
    if (index % 2 === 0) {
      lines.push({
        x1: xPositionOfDottedLine,
        y1: space + 20,
        x2: xPositionOfDottedLine,
        y2: space + 40,
        strokeColor: [1, 0, 0],
      });
    } else {
      lines.push({
        x1: xPositionOfDottedLine,
        y1: space + 20,
        x2: xPositionOfDottedLine,
        y2: space + 40,
        strokeColor: [0, 0, 0, 0],
      });
    }
    space = space + 20;
  }

  return lines;
}
